var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNaviManagerReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.926,
    height: 26.372,
    viewBox: "0 0 20.926 26.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(-2664.545 -198.202)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 15.093,
    height: 20.53,
    rx: 0.928,
    transform: "translate(2670.128 203.794)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_472",
    "data-name": "Line 472",
    x2: 3.469,
    transform: "translate(2672.534 207.507)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_473",
    "data-name": "Line 473",
    x2: 2.818,
    transform: "translate(2680.997 207.507)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_474",
    "data-name": "Line 474",
    x2: 2.166,
    transform: "translate(2672.534 208.625)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_475",
    "data-name": "Line 475",
    x2: 2.166,
    transform: "translate(2675.125 208.625)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_476",
    "data-name": "Line 476",
    x2: 1.274,
    transform: "translate(2672.534 210.34)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_477",
    "data-name": "Line 477",
    x2: 5.267,
    transform: "translate(2674.254 210.34)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_478",
    "data-name": "Line 478",
    x2: 3.886,
    transform: "translate(2679.881 210.34)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_479",
    "data-name": "Line 479",
    x1: 1.776,
    transform: "translate(2681.991 212.023)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_480",
    "data-name": "Line 480",
    x1: 4.062,
    transform: "translate(2677.446 212.023)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_481",
    "data-name": "Line 481",
    x1: 4.522,
    transform: "translate(2672.534 212.023)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_482",
    "data-name": "Line 482",
    x1: 1.274,
    transform: "translate(2682.493 215.664)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_483",
    "data-name": "Line 483",
    x1: 5.267,
    transform: "translate(2676.78 215.664)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_484",
    "data-name": "Line 484",
    x1: 3.886,
    transform: "translate(2672.534 215.664)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_485",
    "data-name": "Line 485",
    x2: 1.776,
    transform: "translate(2672.534 213.981)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_486",
    "data-name": "Line 486",
    x2: 4.062,
    transform: "translate(2674.794 213.981)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_487",
    "data-name": "Line 487",
    x2: 4.522,
    transform: "translate(2679.245 213.981)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_488",
    "data-name": "Line 488",
    x2: 1.798,
    transform: "translate(2678.509 217.347)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_489",
    "data-name": "Line 489",
    x2: 3.185,
    transform: "translate(2680.582 217.347)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_490",
    "data-name": "Line 490",
    x2: 2.047,
    transform: "translate(2672.534 217.347)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_491",
    "data-name": "Line 491",
    x2: 2.279,
    transform: "translate(2675.281 217.347)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_492",
    "data-name": "Line 492",
    x1: 1.274,
    transform: "translate(2682.493 220.713)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_493",
    "data-name": "Line 493",
    x1: 5.267,
    transform: "translate(2676.78 220.713)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_494",
    "data-name": "Line 494",
    x1: 3.886,
    transform: "translate(2672.534 220.713)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_495",
    "data-name": "Line 495",
    x2: 1.776,
    transform: "translate(2672.534 219.03)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_496",
    "data-name": "Line 496",
    x2: 4.062,
    transform: "translate(2674.794 219.03)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_497",
    "data-name": "Line 497",
    x2: 4.522,
    transform: "translate(2679.245 219.03)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_498",
    "data-name": "Line 498",
    x2: 1.798,
    transform: "translate(2678.509 222.396)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_499",
    "data-name": "Line 499",
    x2: 3.185,
    transform: "translate(2680.582 222.396)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_500",
    "data-name": "Line 500",
    x2: 2.047,
    transform: "translate(2672.534 222.396)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_501",
    "data-name": "Line 501",
    x2: 2.279,
    transform: "translate(2675.281 222.396)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_357",
    "data-name": "Rectangle 357",
    width: 15.093,
    height: 20.53,
    rx: 0.928,
    transform: "translate(2667.128 201.129)",
    fill: "#fff",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_502",
    "data-name": "Line 502",
    x2: 3.469,
    transform: "translate(2669.534 204.842)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_503",
    "data-name": "Line 503",
    x2: 2.818,
    transform: "translate(2677.997 204.842)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_504",
    "data-name": "Line 504",
    x2: 2.166,
    transform: "translate(2669.534 205.959)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_505",
    "data-name": "Line 505",
    x2: 2.166,
    transform: "translate(2672.125 205.959)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_506",
    "data-name": "Line 506",
    x2: 1.274,
    transform: "translate(2669.534 207.674)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_507",
    "data-name": "Line 507",
    x2: 5.267,
    transform: "translate(2671.254 207.674)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_508",
    "data-name": "Line 508",
    x2: 3.886,
    transform: "translate(2676.881 207.674)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_509",
    "data-name": "Line 509",
    x1: 1.776,
    transform: "translate(2678.991 209.357)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_510",
    "data-name": "Line 510",
    x1: 4.062,
    transform: "translate(2674.446 209.357)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_511",
    "data-name": "Line 511",
    x1: 4.522,
    transform: "translate(2669.534 209.357)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_512",
    "data-name": "Line 512",
    x1: 1.274,
    transform: "translate(2679.493 212.999)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_513",
    "data-name": "Line 513",
    x1: 5.267,
    transform: "translate(2673.78 212.999)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_514",
    "data-name": "Line 514",
    x1: 3.886,
    transform: "translate(2669.534 212.999)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_515",
    "data-name": "Line 515",
    x2: 1.776,
    transform: "translate(2669.534 211.316)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_516",
    "data-name": "Line 516",
    x2: 4.062,
    transform: "translate(2671.794 211.316)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_517",
    "data-name": "Line 517",
    x2: 4.522,
    transform: "translate(2676.245 211.316)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_518",
    "data-name": "Line 518",
    x2: 1.798,
    transform: "translate(2675.509 214.681)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_519",
    "data-name": "Line 519",
    x2: 3.185,
    transform: "translate(2677.582 214.681)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_520",
    "data-name": "Line 520",
    x2: 2.047,
    transform: "translate(2669.534 214.681)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_521",
    "data-name": "Line 521",
    x2: 2.279,
    transform: "translate(2672.281 214.681)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_522",
    "data-name": "Line 522",
    x1: 1.274,
    transform: "translate(2679.493 218.047)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_523",
    "data-name": "Line 523",
    x1: 5.267,
    transform: "translate(2673.78 218.047)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_524",
    "data-name": "Line 524",
    x1: 3.886,
    transform: "translate(2669.534 218.047)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_525",
    "data-name": "Line 525",
    x2: 1.776,
    transform: "translate(2669.534 216.364)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_526",
    "data-name": "Line 526",
    x2: 4.062,
    transform: "translate(2671.794 216.364)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_527",
    "data-name": "Line 527",
    x2: 4.522,
    transform: "translate(2676.245 216.364)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_528",
    "data-name": "Line 528",
    x2: 1.798,
    transform: "translate(2675.509 219.73)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_529",
    "data-name": "Line 529",
    x2: 3.185,
    transform: "translate(2677.582 219.73)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_530",
    "data-name": "Line 530",
    x2: 2.047,
    transform: "translate(2669.534 219.73)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_531",
    "data-name": "Line 531",
    x2: 2.279,
    transform: "translate(2672.281 219.73)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_358",
    "data-name": "Rectangle 358",
    width: 15.093,
    height: 20.53,
    rx: 0.928,
    transform: "translate(2664.545 198.202)",
    fill: "#113252"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaviManagerReport);
export default __webpack_public_path__ + "static/media/naviManagerReport.e22042191463d732062e07033eb0915b.svg";
export { ForwardRef as ReactComponent };